/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum RangeAssignmentOption {
    ALL = 'all',
    NOT_ASSIGNMENT = 'notAssignment',
    MANUALLY_ASSIGNMENT = 'manuallyAssignment',
}
